// extracted by mini-css-extract-plugin
export default {"intelligence-highlight":"components-hotel-channel-pricing-tables-cells-channels-table-restrictions-channels-table-restrictions-row-cell-content-module__intelligence-highlight"};